export default __webpack_public_path__ + "static/media/DocumentMobileIcon.65709730.svg";